import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "content visible-box" }
const _hoisted_2 = {
  class: "container-fluid",
  id: "itenary-div"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-12",
    id: "top-margin"
  })
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_6 = { class: "mt-5 ml-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_12 = {
  class: "col-sm-7",
  id: "sm-left-div"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  class: "col-sm-12 col-md-12 col-lg-12 col-xl-12",
  id: "sponsors"
}
const _hoisted_15 = {
  key: 0,
  id: "itenaryone",
  class: "container-fluid"
}
const _hoisted_16 = { class: "row display-flex" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  id: "itenarytwo",
  class: "container-fluid"
}
const _hoisted_20 = { class: "row display-flex" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 2,
  id: "itenarythree",
  class: "container-fluid"
}
const _hoisted_26 = { class: "row display-flex" }
const _hoisted_27 = {
  class: "col-6",
  id: "hero-img"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  class: "col-6",
  id: "other-imgs"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 3,
  id: "itenaryfour",
  class: "container-fluid"
}
const _hoisted_32 = { class: "row display-flex" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 4,
  id: "itenary",
  class: "container-fluid five-image-template"
}
const _hoisted_38 = {
  class: "row display-flex",
  id: "itenary-row-5"
}
const _hoisted_39 = {
  class: "col-6",
  id: "hero-img-5"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  class: "col-6",
  id: "other-images-container-5"
}
const _hoisted_42 = {
  class: "row",
  id: "itenaryrow-5"
}
const _hoisted_43 = {
  class: "col-6",
  id: "left-col-5"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  class: "col-6",
  id: "right-col-5"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = { id: "itenary-slider" }
const _hoisted_48 = { class: "carousel" }
const _hoisted_49 = { class: "carousel-inner" }
const _hoisted_50 = ["src", "alt"]
const _hoisted_51 = { id: "itenary-bottom" }
const _hoisted_52 = { class: "col-sm-12" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = {
  class: "col-sm-12 col-md-6 col-lg-6",
  id: "itenary-desc"
}
const _hoisted_55 = { class: "icons" }
const _hoisted_56 = { class: "icons-list" }
const _hoisted_57 = ["src", "alt", "title"]
const _hoisted_58 = {
  class: "capt",
  style: {"color":"#bba756","font-weight":"bold","font-size":"12px"}
}
const _hoisted_59 = { class: "desc" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_61 = { class: "contact" }
const _hoisted_62 = {
  key: 0,
  class: "numbers"
}
const _hoisted_63 = { class: "ph" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 2 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { id: "social-div" }
const _hoisted_69 = { class: "social" }
const _hoisted_70 = ["href"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/fb-icon.png",
    style: {"width":"32px"}
  })
], -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", null, "Facebook", -1)
const _hoisted_74 = ["href"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/in-icon.png",
    style: {"width":"32px"}
  })
], -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", null, "Instagram", -1)
const _hoisted_78 = { id: "business-logo" }
const _hoisted_79 = ["src"]
const _hoisted_80 = { class: "col-sm-12 col-md-6 col-lg-6 p-0" }
const _hoisted_81 = { class: "icons industry-icons" }
const _hoisted_82 = { class: "icons-list" }
const _hoisted_83 = ["src", "alt"]
const _hoisted_84 = { class: "row" }
const _hoisted_85 = {
  key: 0,
  class: "col-sm-12",
  id: "map-smcard"
}
const _hoisted_86 = ["src"]
const _hoisted_87 = {
  key: 1,
  class: "col-sm-6 col-md-6 col-lg-6 text-center",
  id: "amenities"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h2", null, "Amenities", -1)
const _hoisted_89 = {
  key: 2,
  class: "col-sm-6 col-md-6 col-lg-6 text-center",
  id: "features"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("h2", null, "Facilities", -1)
const _hoisted_91 = { class: "col-sm-12" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", null, "Lables: ", -1)
const _hoisted_93 = {
  class: "container-fluid",
  id: "mid-div"
}
const _hoisted_94 = { class: "row" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-lg-2" }, null, -1)
const _hoisted_96 = { class: "col-sm-6 col-md-6 col-lg-6" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-5 ml-2" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-12 col-md-12 col-lg-12 col-xl-12",
    id: "sponsors"
  }, [
    /*#__PURE__*/_createElementVNode("h2", { id: "members-heading" }, "MEMBERS – ALL CATEGORIES SEARCH")
  ])
], -1)
const _hoisted_98 = {
  class: "col-12 col-lg-4",
  id: "card-img"
}
const _hoisted_99 = { class: "carousel" }
const _hoisted_100 = { class: "carousel-inner" }
const _hoisted_101 = ["src", "alt"]
const _hoisted_102 = {
  class: "col-12 col-lg-8",
  id: "smart-search-text"
}
const _hoisted_103 = { style: {"text-transform":"uppercase"} }
const _hoisted_104 = ["href"]
const _hoisted_105 = { class: "category-icons-row" }
const _hoisted_106 = ["src", "alt", "title"]
const _hoisted_107 = {
  key: 0,
  class: "capt-line-caption"
}
const _hoisted_108 = { style: {"color":"#bba756"} }
const _hoisted_109 = {
  key: 1,
  class: "capt-line-intro"
}
const _hoisted_110 = {
  key: 2,
  class: "address-line"
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("b", null, "A:", -1)
const _hoisted_112 = {
  key: 3,
  class: "intro-panel-contact-block"
}
const _hoisted_113 = { class: "ph" }
const _hoisted_114 = {
  key: 0,
  class: "mb"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("b", null, "M:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fis_header = _resolveComponent("fis-header")!
  const _component_bread_crumbs = _resolveComponent("bread-crumbs")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_sponsors_page = _resolveComponent("sponsors-page")!
  const _component_fis_footer = _resolveComponent("fis-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { style: {"overflow":"auto"} }, {
    default: _withCtx(() => [
      _createVNode(_component_fis_header),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_bread_crumbs, { crumbs: _ctx.breadCrumbs }, null, 8, ["crumbs"])
            ]),
            _hoisted_7
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.smcardData['name']), 1)
                ])
              ]),
              (_ctx.images.length == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: image.id,
                            src: _ctx.storageBaseUrl + '/' + image['image']
                          }, null, 8, _hoisted_18))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.images.length == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          src: _ctx.storageBaseUrl + '/' + _ctx.images[0]['image']
                        }, null, 8, _hoisted_22)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("img", {
                          src: _ctx.storageBaseUrl + '/' + _ctx.images[1]['image']
                        }, null, 8, _hoisted_24)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.images.length == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("img", {
                          src: _ctx.storageBaseUrl + '/' + _ctx.images[0]['image'],
                          class: "img-smcard"
                        }, null, 8, _hoisted_28)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images.slice(1), (image) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: image.id,
                            src: _ctx.storageBaseUrl + '/' + image['image'],
                            class: "img-smcard",
                            style: {"padding-bottom":"1px"}
                          }, null, 8, _hoisted_30))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.images.length == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images.slice(0,2), (image) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: image.id,
                            src: _ctx.storageBaseUrl + '/' + image['image'],
                            class: "img-fluid img-padding"
                          }, null, 8, _hoisted_34))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images.slice(2,4), (image) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: image.id,
                            src: _ctx.storageBaseUrl + '/' + image['image'],
                            class: "img-fluid img-padding"
                          }, null, 8, _hoisted_36))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.images.length == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("img", {
                          src: _ctx.storageBaseUrl + '/' + _ctx.images[0]['image'],
                          class: "hero-image-5"
                        }, null, 8, _hoisted_40)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images.slice(1,3), (image) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: image.id,
                                src: _ctx.storageBaseUrl + '/' + image['image'],
                                class: "other-image-5"
                              }, null, 8, _hoisted_44))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images.slice(3,5), (image) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: image.id,
                                src: _ctx.storageBaseUrl + '/' + image['image'],
                                class: "other-image-5"
                              }, null, 8, _hoisted_46))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_swiper, {
                      navigation: true,
                      modules: _ctx.modules,
                      id: "search-swipe"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, imgIdx) => {
                          return (_openBlock(), _createBlock(_component_swiper_slide, {
                            key: image.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", _mergeProps({
                                class: "d-block",
                                src: _ctx.storageBaseUrl + '/' + image['image'],
                                alt: _ctx.smcardData['name'] || 'Photo',
                                style: {"width":"100%"}
                              }, _ctx.introCarouselImgAttrs(0, imgIdx)), null, 16, _hoisted_50)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modules"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("ul", _hoisted_56, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smcardData.categories, (category) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: category.id
                            }, [
                              _createElementVNode("img", _mergeProps({
                                src: _ctx.storageBaseUrl + '/' + category.black_path,
                                alt: category.name,
                                title: category.name
                              }, _ctx.lazyImageAttrs()), null, 16, _hoisted_57),
                              _createElementVNode("p", null, _toDisplayString(category.name), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("em", null, _toDisplayString(_ctx.smcardData.caption), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.smcardData.description), 1)
                      ]),
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        (!_ctx.shouldHidePhone(_ctx.smcardData))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.smcardData.phone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.phoneLineLetter) + ": " + _toDisplayString(_ctx.phone), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_64,
                              (_ctx.smcardData.mobile)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_65, "M: " + _toDisplayString(_ctx.mobile), 1))
                                : _createCommentVNode("", true),
                              (_ctx.smcardData.email)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_66, "E: " + _toDisplayString(_ctx.smcardData.email), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, "A: " + _toDisplayString(_ctx.smcardData.clean_address), 1),
                        (_ctx.smcardData.website)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_67, "W: " + _toDisplayString(_ctx.smcardData.website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0]), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("ul", _hoisted_69, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: _ctx.smcardData.facebook || 'https://www.facebook.com/',
                                target: "_blank",
                                rel: "noopener noreferrer",
                                title: "Facebook"
                              }, _hoisted_72, 8, _hoisted_70),
                              _hoisted_73
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: _ctx.smcardData.instagram || 'https://www.instagram.com/',
                                target: "_blank",
                                rel: "noopener noreferrer",
                                title: "Instagram"
                              }, _hoisted_76, 8, _hoisted_74),
                              _hoisted_77
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        (_ctx.smcardData.logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.storageBaseUrl + '/' + _ctx.smcardData.logo,
                              style: {"float":"right","width":"60%"}
                            }, null, 8, _hoisted_79))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("ul", _hoisted_82, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueIndustrySymbols, (symbol, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `symbol-${symbol.id}-${index}`
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/' + symbol.icon_path,
                                alt: symbol.name
                              }, null, 8, _hoisted_83),
                              _createElementVNode("p", null, _toDisplayString(symbol.name), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        (_ctx.smcardData.address)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _createElementVNode("iframe", {
                                src: _ctx.mapEmbedUrl,
                                width: "100%",
                                height: "220",
                                style: {"border":"1px solid black","border-radius":"4px"},
                                allowfullscreen: "",
                                loading: "lazy",
                                referrerpolicy: "no-referrer-when-downgrade",
                                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMapError && _ctx.handleMapError(...args)))
                              }, "\n                        ", 40, _hoisted_86)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.smcardData.amenities)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                              _hoisted_88,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smcardData.amenities, (amenity) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: amenity.id
                                }, _toDisplayString(amenity.name), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.smcardData.facilities)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _hoisted_90,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smcardData.facilities, (facility) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: facility.id
                                }, _toDisplayString(facility.name), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _hoisted_92,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smcardData.labels, (label) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: label.id,
                      class: "badge badge-pill badge-primary",
                      style: {"margin":"0px 5px"}
                    }, _toDisplayString(label.name), 1))
                  }), 128))
                ])
              ])
            ]),
            _createVNode(_component_sponsors_page, {
              "total-sponsors": 6,
              style: {"margin-top":"5px"}
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _hoisted_95,
            _createElementVNode("div", _hoisted_96, [
              _hoisted_97,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.introPanels, (introPanel, panelIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row search-intro-panel g-0",
                  id: "business-card",
                  key: introPanel.id
                }, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(_component_swiper, {
                          navigation: introPanel['images'].length > 1,
                          modules: _ctx.modules,
                          id: "search-swipe"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introPanel['images'], (images, slideIndex) => {
                              return (_openBlock(), _createBlock(_component_swiper_slide, {
                                key: images.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", _mergeProps({
                                    class: "d-block",
                                    src: _ctx.storageBaseUrl + '/' + images['image'],
                                    alt: introPanel.name || 'Member listing',
                                    style: {"width":"100%"}
                                  }, _ctx.introCarouselImgAttrs(panelIndex, slideIndex)), null, 16, _hoisted_101)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["navigation", "modules"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("h2", _hoisted_103, [
                      _createElementVNode("a", {
                        href: '/smartcard/'+introPanel.id,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(introPanel.name), 9, _hoisted_104)
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introPanel.categories, (category) => {
                        return (_openBlock(), _createElementBlock("img", _mergeProps({
                          key: category.id,
                          src: _ctx.storageBaseUrl + '/' + category.black_path,
                          alt: category.name,
                          title: category.name
                        }, _ctx.lazyImageAttrs()), null, 16, _hoisted_106))
                      }), 128))
                    ]),
                    (introPanel.caption)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_107, [
                          _createElementVNode("em", _hoisted_108, _toDisplayString(introPanel.caption), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (introPanel.intro)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_109, _toDisplayString(introPanel.intro), 1))
                      : _createCommentVNode("", true),
                    (introPanel.clean_address)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_110, [
                          _hoisted_111,
                          _createTextVNode(" " + _toDisplayString(introPanel.clean_address), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.shouldHidePhone(introPanel))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                          _createElementVNode("p", _hoisted_113, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.isAustralianMobile(introPanel.formatted_phone) ? 'M' : 'P') + ":", 1),
                            _createTextVNode(" " + _toDisplayString(introPanel.formatted_phone), 1)
                          ]),
                          (introPanel.formatted_mobile && String(introPanel.formatted_mobile).length > 6)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_114, [
                                _hoisted_115,
                                _createTextVNode(_toDisplayString(introPanel.formatted_mobile), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_fis_footer)
      ])
    ]),
    _: 1
  }))
}